(function () {
  function sortCards(cards, value) {
    return cards.sort(function (a, b) {
      if (value === 'oldest') return Number(a.dataset.date) - Number(b.dataset.date);
      if (value === 'newest') return Number(b.dataset.date) - Number(a.dataset.date);
      if (value === 'title-asc') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      if (value === 'title-desc') return (b.dataset.title || '').localeCompare(a.dataset.title || '');
      return Number(a.dataset.index) - Number(b.dataset.index);
    });
  }

  function render(listing, page) {
    var perPage = Number(listing.dataset.perPage) || 12;
    var select = listing.querySelector('.blog-listing__sort-select');
    var grid = listing.querySelector('.blog-listing__grid');
    var nav = listing.querySelector('.blog-listing__pagination');
    if (!grid) return;

    var value = select ? select.value : '';
    var cards = sortCards(Array.prototype.slice.call(grid.querySelectorAll('.blog-card')), value);
    cards.forEach(function (card) {
      grid.appendChild(card);
    });

    var totalPages = Math.max(1, Math.ceil(cards.length / perPage));
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;

    var start = (page - 1) * perPage;
    var end = start + perPage;
    cards.forEach(function (card, index) {
      card.classList.toggle('is-hidden', index < start || index >= end);
    });

    if (!nav) return;
    if (totalPages <= 1) {
      nav.hidden = true;
      nav.innerHTML = '';
      return;
    }

    var html = '';
    if (page > 1) {
      html += '<a class="prev" href="#blog-page" data-blog-page="' + (page - 1) + '">« Previous</a>';
    }
    for (var i = 1; i <= totalPages; i++) {
      if (i === page) html += '<span class="current">' + i + '</span>';
      else html += '<a class="page" href="#blog-page" data-blog-page="' + i + '">' + i + '</a>';
    }
    if (page < totalPages) {
      html += '<a class="next" href="#blog-page" data-blog-page="' + (page + 1) + '">Next »</a>';
    }
    nav.innerHTML = html;
    nav.hidden = false;
  }

  document.querySelectorAll('.blog-listing').forEach(function (listing) {
    var select = listing.querySelector('.blog-listing__sort-select');
    var nav = listing.querySelector('.blog-listing__pagination');

    if (select) {
      select.addEventListener('change', function () {
        render(listing, 1);
      });
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var link = e.target.closest('[data-blog-page]');
        if (!link) return;
        e.preventDefault();
        render(listing, Number(link.getAttribute('data-blog-page')));
        listing.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    render(listing, 1);
  });
})();
